export const ONLINE = 'STS23001'
export const OFFLINE = 'STS23002'